import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { Match, MatchState } from '../../shared/model/match';
import { OpenSquashService } from '../../shared/services/open-squash-service';

@Component({
  selector: 'app-create-match-component',
  imports: [CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule],
  templateUrl: './create-match-component.html',
  styleUrl: './create-match-component.scss'
})
export class CreateMatchComponent {
  private dialogRef = inject(MatDialogRef<CreateMatchComponent>);
  private fb = inject(FormBuilder);
  private data = inject(MAT_DIALOG_DATA);

  private openSquashService = inject(OpenSquashService);

  form: FormGroup = this.fb.group({
    category: [this.data?.categoryType, Validators.required],
    groupName: [this.data?.groupName, Validators.required],
    date: [new Date()],
    time: [''], // tipo 'HH:mm'
    player1Id: ['', Validators.required],
    player2Id: ['', Validators.required],
    court: [''],
    bestOf: [3],
    pointsToWin: [11]
  });

  submit() {
    if (!this.form.valid) {
      return;
    }

    const valueForm = this.form.value;
    const date = new Date(valueForm.date);
    if (valueForm.time) {
      const [hours, minutes] = valueForm.time.split(':');
      date.setHours(+hours, +minutes, 0);
    } else{
      date.setHours(0, 0, 0);
    }

    // Obtener el primer caracter en mayúscula de category y groupName
    const categoryInitial = valueForm.category?.charAt(0).toUpperCase() || '';
    const groupInitial = valueForm.groupName?.charAt(0).toUpperCase() || '';

    const match = {
      code: `P${categoryInitial}${groupInitial}-${valueForm.player1Id}-${valueForm.player2Id}`,
      tournamentId: this.openSquashService.tournamentId,
      category: valueForm.category,
      groupName: valueForm.groupName,
      date: date,
      player1Id: valueForm.player1Id,
      player2Id: valueForm.player2Id,
      court: valueForm.court,
      bestOf: valueForm.bestOf || 3,
      pointsToWin: valueForm.pointsToWin || 11,
      state: MatchState.PROGRAMADO
    } as Match;

    this.openSquashService.createMatch(match).subscribe((match) => {
      this.dialogRef.close(match);
    });
  }

  exit() {
    this.dialogRef.close(null);
  }
}